import script from "./SummaryReportIssueTop.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryReportIssueTop.vue?vue&type=script&setup=true&lang=js"

import "./SummaryReportIssueTop.vue?vue&type=style&index=0&id=59b9d7fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59b9d7fc"]])

export default __exports__